/*
 *  -----------------------------------------------------------------------
 *    <copyright file="add-visit-form.constants.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

export interface initialStateVisitFormInterface {
    configId: string | null;
    active: boolean;
    type: string;
    visitId: string;
    visitName: string;
    leadVisitId: string;
    leadPeriod: number;
    leadUnit: string;
    minWinPeriod: number;
    maxWinPeriod: number;
    minWinUnit: string;
    minOccurrences: number;
    eventIds: string[];
    forecastEndDate: string[];
    endDateUsage: string;
    recordId: string;
    sequenceNumber: number | null;
}

export interface initialErrorVisitFormInterface {
    [key: string]: string | null;
    configId: string | null;
    type: string | null;
    visitId: string | null;
    visitName: string | null;
    leadVisitId: string | null;
    leadUnit: string | null;
    leadPeriod: string | null;
    minWinPeriod: string | null;
    maxWinPeriod: string | null;
    minWinUnit: string | null;
    minOccurrences: string | null;
    forecastEndDate: string | null;
    endDateUsage: string | null;
}

export const initialStateVisitForm: initialStateVisitFormInterface = {
    configId: null,
    active: true,
    type: '',
    visitId: '',
    visitName: '',
    leadVisitId: '',
    leadPeriod: 0,
    leadUnit: '',
    minWinPeriod: 0,
    maxWinPeriod: 0,
    minWinUnit: '',
    minOccurrences: 1,
    eventIds: [],
    forecastEndDate: [],
    endDateUsage: '',
    recordId: '',
    sequenceNumber: null,
};
export const initialErrorVisitForm: initialErrorVisitFormInterface = {
    configId: null,
    type: '',
    visitId: '',
    visitName: '',
    leadVisitId: '',
    leadUnit: '',
    leadPeriod: '',
    minWinPeriod: '',
    maxWinPeriod: '',
    minWinUnit: '',
    minOccurrences: '',
    forecastEndDate: '',
    endDateUsage: '',
};
